<template>
  <portlet
          :icon="'fad fa-user-chart'"
          :title="getWorkflowName(workflowId)"
          :actionsBlock="true"
          :footer="true"
          class="product-workflow-kpis"
  >
    <template slot="actionsBlock">
      <back-button :link="'products'"/>
    </template>

    <template slot="portletBody">
      <kpi-unit-setting
              v-for="(kpi, index) in kpis"
              :kpi=kpi
              :workflowId="workflowId"
              :key="index"
              @changedKpiUnit="updatedKpiUnits($event)"
              @unsavedChanges="hasUnsavedChanges($event)"
      />
      <div class="alert alert-info" role="alert" v-if="!kpis.length">
        {{ $t('products.workflows.noneAssigned')}}
      </div>
    </template>

    <div class="col text-right" slot="portletFooter" v-if="kpis.length">
      <router-link :to="{name:'products'}" class="btn btn-cancel">
        {{$t('ui.cancel')}}
      </router-link>
      <button @click="saveWorkflowUnits" class="btn btn-primary ml-4" type="submit">{{$t('ui.save')}}</button>
    </div>
  </portlet>

</template>

<script>
  import {mapGetters} from 'vuex'
  import kpiUnitSetting from './ProductKpiSettings'
  import {EasyFirestore} from '../../mixins/EasyFirestore'

  //@vuese
  // @group Products
  export default {
    name: 'ProductWorkflowUnits',
    props: ['product', 'workflowId'],
    mixins: [EasyFirestore],
    components: {
      kpiUnitSetting
    },
    data() {
      return {
        kpis: [],
        editedKpiUnits: []
      }
    },
    computed: {
      ...mapGetters('workflows', [
        'getWorkflowName'
      ]),
    },
    methods: {
      //@vueuse
      hasUnsavedChanges(event) {
        this.$emit('unsavedChanges', event);
      },
      //@vueuse
      updatedKpiUnits(val) {
        let editedKpiUnits = this.editedKpiUnits;
        let index = _.findIndex(editedKpiUnits, {id: val.id});
        if(index !== -1) {
          editedKpiUnits.splice(index, 1, val)
        } else {
          editedKpiUnits.push(val)
        }
        return editedKpiUnits
      },
      //@vueuse
      saveWorkflowUnits() {
        let self = this;
        self.$store.dispatch('productKpiUnits/setPathVars', {productID: this.$route.params.id}).then(() => {
          self.$store.dispatch('productKpiUnits/insertBatch', this.editedKpiUnits).then(() => {
            self.swalToastSuccess(this.$t('products.updated'));
            self.$emit('unsavedChanges', false);
          })
        })
      }
    },
  }
</script>